import { isMobile, handleCookieBar } from "./helper";
import SiteHeader from "./siteHeader";
import { toggleMenu, addSticky, closeMenu } from "./navigation";
import FloatLabels from "./forms/float-labels";
// import offerTiles from "./offerTiles";
// import teamMembersPopup from "./teamMembersPopup";
// import AjaxLoadPosts from "./AjaxLoadPosts";
import "./trusted-by-slider";
// import "./linkedinHover";

window.addEventListener("load", () => {
	const siteHeader = new SiteHeader();
	siteHeader.setStickyHeader();
	new FloatLabels();

	// const offerTilesContainer = document.querySelector(".offer-tiles");
	// if (offerTilesContainer) {
	// 	offerTiles(offerTilesContainer);
	// }

	const teamMembersContainer = document.querySelector(".team-members-listing");
	const teamMembersSliderContainer = document.querySelector(
		".team-members-slider-container"
	);
	const contactPeopleWrapper = document.querySelector(
		".contact-people-wrapper"
	);

	const teamMemberAside = document.querySelector(".aside-members");

	// if (teamMembersContainer) {
	// 	teamMembersPopup(teamMembersContainer);
	// }

	// if (teamMembersSliderContainer) {
	// 	teamMembersPopup(teamMembersSliderContainer);
	// }

	// if (teamMemberAside) {
	// 	teamMembersPopup(teamMemberAside);
	// }
	// if (contactPeopleWrapper) {
	// 	teamMembersPopup(contactPeopleWrapper);
	// }

	// const categoriesMenu = document.querySelector(".categories-menu");
	// if (categoriesMenu) {
	// 	new AjaxLoadPosts(categoriesMenu);
	// }

	const cookieBanner = document.querySelector(".cookie-banner");
	if (cookieBanner) {
		handleCookieBar(cookieBanner);
	}

	toggleMenu();

	if (isMobile()) {
		closeMenu();
		addSticky();
	}
});

window.onresize = () => {
	if (isMobile()) {
		closeMenu();
		addSticky();
	}
};
